import { MateSpriteMode } from "@/types/game";
import { getAvatarKey, IMateCharacter } from "./character-utils";
const PADDING = 4;
const GAP = 16;
// 过滤掉文本中括号内的内容
const filterBracketContent = (text: string): string => {
  return text.replace(/(\(|（).*?(\)|）)/g, "").replace(/^\n+|\n+$/g, "");
};
export const hideTextBubble = (
  char: IMateCharacter,
  onComplete?: () => void
) => {
  if (char.textBubble && char.textBubble?.scene?.tweens) {
    const scene = char.textBubble.scene;
    scene.tweens.add({
      targets: char.textBubble,
      alpha: 0,
      scaleY: 0,
      duration: 200,
      ease: "Power2",
      onComplete: () => {
        if (char.textBubble) {
          char.textBubble.parentContainer.destroy();
          char.textBubble = undefined;
        }
        onComplete?.();
      },
    });
  } else {
    onComplete?.();
  }
};

export const showTextBubble = (
  scene: Phaser.Scene,
  text: string,
  char: IMateCharacter,
  options?: {
    autoHide?: boolean;
    durationSec?: number;
    showAvatar?: boolean;
  }
) => {
  const {
    autoHide = true,
    durationSec = 10,
    showAvatar = true,
  } = options || {};
  // 过滤括号内的内容
  const t = filterBracketContent(text);
  const filteredText = `${t}`;
  return new Promise<Phaser.GameObjects.Text>((resolve) => {
    // 先隐藏现有的气泡
    hideTextBubble(char, () => {
      const { textBubble, bubbleContainer } = createTextBubble(
        scene,
        filteredText,
        char,
        { showAvatar }
      );
      if (showAvatar) {
        const bgX = 0;
        const bgY = textBubble.y + textBubble.height / 2;
        const bgWidth = textBubble.width + GAP + PADDING * 2;
        const bgHeight = textBubble.height + GAP;
        const background = scene.add.rectangle(
          bgX,
          bgY,
          bgWidth,
          bgHeight,
          0x000000
          // 0.6
        );
        background.setOrigin(0.5);
        bubbleContainer.add(background);
        bubbleContainer.sendToBack(background);
        // 添加黑色背景
        if (char.mate.mediaUrl) {
          const avatarWidth = 80;
          const avatarHeight = avatarWidth / (3 / 4);
          const avatar = scene.add.image(
            0,
            textBubble.y + avatarHeight / 2,
            getAvatarKey(char.mate)
          );

          avatar.setDisplaySize(avatarWidth, avatarHeight);
          avatar.setPosition(bgX - bgWidth / 2 - avatarWidth / 2, bgY);
          bubbleContainer.add(avatar);
        }
      }

      // 添加显示动画
      scene.tweens.add({
        targets: textBubble,
        alpha: 1,
        scaleY: 1,
        duration: 200,
        ease: "Back.easeOut",
        onComplete: () => {
          resolve(textBubble);

          // 10秒后自动隐藏
          scene.time.delayedCall(durationSec * 1000, () => {
            if (
              autoHide &&
              char.textBubble &&
              char.textBubble.text === textBubble.text
            ) {
              hideTextBubble(char);
            }
          });
        },
      });

      char.textBubble = textBubble;
    });
  });
};

const createTextBubble = (
  scene: Phaser.Scene,
  text: string,
  char: IMateCharacter,
  options: {
    showAvatar?: boolean;
  }
) => {
  const { showAvatar = true } = options || {};
  const bubbleContainer = scene.add.container(0, 0);
  char.container.add(bubbleContainer);
  const textBubble = scene.add.text(0, 0, text, {
    fontSize: "12px",
    fontFamily: "Cubic",
    color: "#fff",
    // backgroundColor: "#000",
    padding: {
      left: PADDING,
      right: PADDING,
      top: PADDING,
      bottom: PADDING,
    },
  });
  const width = Math.min(textBubble.width, 300);
  // const width = 300;
  textBubble.setWordWrapWidth(width, true);
  textBubble.setDepth(9999);
  bubbleContainer.add(textBubble);
  textBubble.setPosition(
    -width / 2,
    char.mateSprite.mode === MateSpriteMode.Compose
      ? -textBubble.height + 32
      : -textBubble.height + (showAvatar ? PADDING : 0)
  );

  // 设置初始状态
  textBubble.setAlpha(0);
  textBubble.setScale(1, 0);
  return { textBubble, bubbleContainer };
};
